import Scroller from './components/Scroller.js';
import Animator from './components/Animator.js';
import CardThreeD from './components/CardThreeD.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = { Animator, Scroller, CardThreeD };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
